module.exports = __webpack_public_path__ + "9fe93f9ddc92b69d33cb8e0512c815a0.jpg";